import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { JsonRenderView } from "./JsonRenderView";
import { submitTransaction } from "../utils/transaction";
export function InteractiveJsonRenderView({ document, className = "", style, client, contractId, walletAddress, onPathChange, onTransactionStart, onTransactionComplete, onError, onInclude, }) {
    const handleTransaction = useCallback(async (method, args) => {
        if (!client || !contractId || !walletAddress) {
            onError?.("Wallet not connected");
            return;
        }
        // Automatically add caller for contract methods that require auth
        const txArgs = {
            ...args,
            caller: walletAddress,
        };
        onTransactionStart?.();
        const result = await submitTransaction(client, contractId, { method, args: txArgs }, walletAddress);
        onTransactionComplete?.(result);
        if (!result.success && result.error) {
            // Pass the full ParsedError to onError
            onError?.(result.error);
        }
    }, [client, contractId, walletAddress, onTransactionStart, onTransactionComplete, onError]);
    const handleFormSubmit = useCallback(async (method, formData) => {
        if (!client || !contractId || !walletAddress) {
            onError?.("Wallet not connected");
            return;
        }
        // Check if required inputs are filled
        const hasValues = Object.values(formData).some((v) => v !== "" && v !== null && v !== undefined);
        if (!hasValues) {
            onError?.("Please fill in the form fields");
            return;
        }
        // Automatically add caller for contract methods that require auth
        const args = {
            ...formData,
            caller: walletAddress,
        };
        onTransactionStart?.();
        const result = await submitTransaction(client, contractId, { method, args }, walletAddress);
        onTransactionComplete?.(result);
        if (!result.success && result.error) {
            onError?.(result.error);
        }
    }, [client, contractId, walletAddress, onTransactionStart, onTransactionComplete, onError]);
    return (_jsx(JsonRenderView, { document: document, className: className, style: style, onPathChange: onPathChange, onTransaction: handleTransaction, onFormSubmit: handleFormSubmit, onInclude: onInclude }));
}
//# sourceMappingURL=InteractiveJsonRenderView.js.map